import React from 'react';
import { BookIcon } from './Icons';
import styles from '../styles/DisclaimerBanner.module.css';

/**
 * Disclaimer Banner ("billboard")
 * Rendered from the <Disclaimer:{}> content tag, which Sophia places at the
 * START of any response containing guideline-level financial guidance.
 *
 * The text is fixed here on purpose — the tag carries no data, so the wording
 * can never vary message to message.
 */
function DisclaimerBanner() {
  return (
    <div className={styles.disclaimerBanner} role="note">
      <BookIcon size={14} className={styles.disclaimerIcon} />
      <span className={styles.disclaimerText}>
        Educational information only — not financial advice
      </span>
    </div>
  );
}

export default DisclaimerBanner;
